import React from 'react';

const EpisodicMemoryBox = () => {
  return (
    <div className="p-4 bg-gray-100 rounded-md border border-gray-300 text-sm">
      <div className="text-xs text-gray-700">
        Episodic Memory Content
      </div>
    </div>
  );
};

export default EpisodicMemoryBox;